import { sidebar as sidebarFa, fields as fieldsFa } from "./fa";
import { sidebar as sidebarEn, fields as fieldsEn } from "./en";

const locales = {
  en: {
    ...fieldsEn,
    ...sidebarEn,
  },
  fa: {
    ...fieldsFa,
    ...sidebarFa,
  },
};

export default locales;
